/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Edit_HelpInputs */



/**
* | output |
* | --- |
* | "Double-click any cell to edit. Click \"Save\" to commit changes." |
*
* @param {Knp_Lookup_Edit_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_edit_help = /** @type {((inputs?: Knp_Lookup_Edit_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Edit_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Double-cliquez sur une cellule pour modifier. Cliquez sur \"Enregistrer\" pour valider les changements.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Doppelklicken Sie auf eine beliebige Zelle, um sie zu bearbeiten. Klicken Sie auf „Speichern“, um die Änderungen zu übernehmen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fare doppio clic su una cella qualsiasi per modificarla. Fare clic su \"Salva\" per salvare le modifiche.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для редактирования дважды щелкните любую ячейку. Нажмите «Сохранить», чтобы подтвердить изменения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga doble clic en cualquier celda para editarla. Haga clic en \"Guardar\" para confirmar los cambios.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("双击任意单元格即可编辑。点击“保存”按钮提交更改。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集するには、任意のセルをダブルクリックしてください。「保存」をクリックして変更を確定してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("किसी भी सेल को संपादित करने के लिए उस पर दो बार क्लिक करें। परिवर्तन को सेव करने के लिए \"सेव\" पर क्लिक करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clique duas vezes em qualquer célula para editar. Clique em \"Salvar\" para confirmar as alterações.")
	return /** @type {LocalizedString} */ ("Double-click any cell to edit. Click \"Save\" to commit changes.")
});